import { NgModule } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedPageModule } from '@Work/Accounts/proprietary/pages/shared-page.module';
import { ValidationDialogComponent } from './validation-dialog.component';

@NgModule({
    imports: [SharedPageModule, NgbTooltipModule],
    declarations: [ValidationDialogComponent]
})
export class ValidationDialogModule { }
